import * as React from "react";
import { makeStyles } from "@material-ui/styles";
import { fontFamilyHelvetica } from "@styles/type.styles";
import { colors, greys } from "@styles/color.styles";
import { CwIcon } from "@ui/cw-icon";
import { CwLink } from "@ui/cw-link";
import classnames from "classnames";

const useStyles = makeStyles({
  container: {
    border: `1px solid ${colors.green.lighter}`,
    background: "rgba(211, 247, 217, 0.25)",
    borderRadius: 4,
    "& > div": {
      padding: "12px 15px",
    },
    marginBottom: 16,
  },
  container__fixed: {
    border: `1px solid ${greys.cloudyBlue}`,
    background: "none",
  },
  smartHold__type: {
    display: "flex",
    alignItems: "center",
    borderBottom: `1px solid ${colors.green.lighter}`,

    "& > p ": {
      margin: 0,
      fontFamily: fontFamilyHelvetica,
      color: colors.green.darker,
      fontSize: `${14 / 16}rem`,
      fontWeight: 700,
      lineHeight: "18px",
    },
  },
  smartHold__type__fixed: {
    borderBottom: `1px solid ${greys.cloudyBlue}`,

    "& > p ": {
      color: colors.peach.darker,
    },
  },
  settingsLink: {
    "& > p": {
      color: colors.green.darker,
      marginTop: 2,
    },
  },
  settingsLink__fixed: {
    "& > p": {
      color: colors.peach.darker,
    },
  },
  action: {
    borderBottom: `1px solid ${colors.green.lighter}`,
    display: "flex",
    alignItems: "center",
    padding: "8px 15px",
  },
  action__fixed: {
    borderBottom: `1px solid ${greys.cloudyBlue}`,
  },
  body: {
    margin: 0,
    fontFamily: fontFamilyHelvetica,
    color: greys.darkestGrey,
    fontSize: `${14 / 16}rem`,
    fontWeight: 400,
    lineHeight: "18px",
  },
});

export type SmartHoldDetailsProps = {
  label: string;
  action?: React.ReactNode;
  description: React.ReactNode;
  onClickSettings: () => void;
  isFixed: boolean;
};

export const SmartHoldDetails = ({
  label,
  action,
  description,
  onClickSettings,
  isFixed,
}: SmartHoldDetailsProps) => {
  const classes = useStyles();

  return (
    <div className={classnames(classes.container, { [classes.container__fixed]: isFixed })}>
      <div
        className={classnames(classes.smartHold__type, {
          [classes.smartHold__type__fixed]: isFixed,
        })}
      >
        <CwIcon color={isFixed ? "Peach" : "Green"} variant="autopilot" />
        <p>{label}</p>
      </div>
      {action && (
        <div
          className={classnames(classes.action, classes.body, {
            [classes.action__fixed]: isFixed,
          })}
        >
          {action}
        </div>
      )}
      <div>
        <p className={classes.body}>{description}</p>
        <div>
          <CwLink
            size={14}
            onClick={onClickSettings}
            className={classnames(classes.settingsLink, { [classes.settingsLink__fixed]: isFixed })}
          >
            View Settings
          </CwLink>
        </div>
      </div>
    </div>
  );
};
